const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'login',
    allowAnonymous: true,
    component: () => import(/* webpackChunkName: "home" */ '../views/AppLogin.vue'),
    meta: {
      title: 'KGB Aviation',
    },
  },
  {
    path: '/logout',
    name: 'logout',
    allowAnonymous: true,
    component: () => import(/* webpackChunkName: "home" */ '../views/AppLogout.vue'),
    meta: {
      title: 'KGB Aviation',
    },
  },
  {
    path: '/account',
    name: 'account',
    component: () => import(/* webpackChunkName: "account" */ '../views/UserAccount.vue'),
    meta: {
      title: 'Account',
    },
  },
  {
    path: '/updatePassword',
    name: 'updatePassword',
    component: () => import(/* webpackChunkName: "updatePassword" */ '@/views/UpdatePassword.vue'),
    meta: {
      title: 'Update Password',
    },
  },
  {
    path: '/devices',
    name: 'devices',
    component: () => import(/* webpackChunkName: "devices" */ '../views/AppDevices.vue'),
    meta: {
      title: 'Devices',
    },
  },
  {
    path: '/forgot',
    name: 'forgot',
    allowAnonymous: true,
    component: () => import(/* webpackChunkName: "forgot" */ '../views/AppForgot.vue'),
    meta: {
      title: 'Forgot Password',
    },
  },
  {
    path: '/reset/:token',
    name: 'reset',
    allowAnonymous: true,
    component: () => import('../views/ResetPassword.vue'),
    meta: {
      title: 'Reset Password',
    },
  },
  {
    path: '/confirm/:token',
    name: 'confirm',
    allowAnonymous: true,
    component: () => import('@/views/ConfirmAccount.vue'),
    meta: {
      title: 'Confirm Account',
    },
  },
  {
    path: '/organizations',
    name: 'organizations',
    component: () => import(/* webpackChunkName: "organizations" */ '../views/AppOrganizations.vue'),
    meta: {
      title: 'Organizations',
    },
  },
  {
    path: '/sites',
    name: 'sites',
    component: () => import(/* webpackChunkName: "sites" */ '../views/AppSites.vue'),
    meta: {
      title: 'Sites',
    },
  },
  {
    path: '/register',
    name: 'register',
    allowAnonymous: true,
    component: () => import(/* webpackChunkName: "register" */ '../views/AppRegister.vue'),
    meta: {
      title: 'Register Title',
    },
  },
  {
    path: '/users',
    name: 'users',
    component: () => import(/* webpackChunkName: "users" */ '../views/AppUsers.vue'),
    meta: {
      title: 'Users',
    },
  },
  {
    path: '/reporting',
    name: 'reporting',
    component: () => import(/* webpackChunkName: "reporting" */ '../views/AppReporting.vue'),
    meta: {
      title: 'Reporting',
    },
  },
  {
    path: '/usage',
    name: 'usage',
    component: () => import(/* webpackChunkName: "usage" */ '../views/DartUsage.vue'),
    meta: {
      title: 'Usage',
    },
  },
  {
    path: '/testResults',
    name: 'testResults',
    component: () => import(/* webpackChunkName: "testResults" */ '@/views/TestResults.vue'),
    meta: {
      title: 'Test Results',
    },
  },
  {
    path: '/management',
    name: 'management',
    component: () => import(/* webpackChunkName: "management" */ '../views/AppManagement.vue'),
    meta: {
      title: 'Management',
    },
  },
  {
    path: '/testFixtures',
    name: 'testFixtures',
    component: () => import(/* webpackChunkName: "testFixture" */ '@/views/TestFixture.vue'),
    meta: {
      title: 'Test Fixtures',
    },
  },
  {
    path: '/testFixtureResults',
    name: 'testFixtureResults',
    component: () => import(/* webpackChunkName: "testFixture" */ '@/views/TestFixtureResults.vue'),
    meta: {
      title: 'Cable Test Results',
    },
  },
  {
    path: '/programmaticAccess',
    name: 'programmaticAccess',
    component: () => import(/* webpackChunkName: "programmaticAccess" */ '@/views/ProgrammaticAccess.vue'),
    meta: {
      title: 'Programmatic Access',
    },
  },
  {
    path: '/apiDocumentation',
    name: 'apiDocumentation',
    component: () => import(/* webpackChunkName: "apiDocumentation" */ '@/views/ApiDocumentation.vue'),
    meta: {
      title: 'API Documentation',
    },
  },
];

export default routes;
